import React from 'react';

const LoadingSpinner = ({ message = 'Loading...' }) => {
  return (
    <div className="min-h-screen bg-[#18181b] flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-16 w-16 border-b-4 border-[var(--accent-500)] mx-auto mb-4"></div>
        <p className="text-[#efeff1] text-lg">{message}</p>
      </div>
    </div>
  );
};

export default LoadingSpinner; 